module.exports = __webpack_public_path__ + "static/img/noData.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/noData.png
// module id = VbHD
// module chunks = 2